export class DtoCobranza {
    numeroCobranza: number;
    fechaPreparacion: Date;
    fechaCobranza: Date;
    clienteNum: any;
    clienteNombre: string;
    estado: string;
    vendedor: string;    
    unidadReplicacion: string;
    clienteNomb: string;
}